import React from 'react'

import { BrightcoveVideo } from '../Video/BrightcoveVideo'

export type HighlightVideoProps = {
  videoId: string
}

export const HighlightVideo = ({ videoId }: HighlightVideoProps) => {
  let videoplayerId = ''
  if (videoId) {
    videoplayerId = videoId
  } else {
    videoplayerId = ''
  }
  // RWR 1868: updating video wrapper classes
  return (
    <div className="frw-video">
      <BrightcoveVideo videoId={videoplayerId} />
    </div>
  )
}
export default HighlightVideo
